import React, { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { IoCloseSharp } from 'react-icons/io5'
import { GoAlertFill } from 'react-icons/go'
import DetailsPayslip from '../detailsPayslip'
import { FaClock, FaEye, FaLock, FaLockOpen } from 'react-icons/fa'
import { IoIosArrowForward } from 'react-icons/io'
import { payslipTranslate } from '../../../i18n/translatedMessages'
import PaySlipResult from '../payslipResult'
import Payroll from '../../../API/Payroll/Payroll.js'
import List from '../../../API/Lists/Lists.js'
import Loading from '../../Loading/Loading'
import countryMapper from '../../../Utils/CountriesMapper.js'

const monthsInSpanish = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

const monthsInPt = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julio', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

const EmployeePayslip = () => {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const [loading, setLoading] = useState(true)

	const [showPaySlip, setShowPaySlip] = useState(false)
	const [showDetails, setShowDetails] = useState(false)
	const [payslipList, setPayslipList] = useState()
	const [countries, setCountries] = useState()
	const [selectedData, setSelectedData] = useState({
		validatedBy: null,
		id: '',
	})

	const [filters, setFilters] = useState({
		year: '',
		status: '',
		month: '',
		country: '',
	})

	const getMonthTranslate = monthNumber => {
		if (language === 'es') return monthsInSpanish[monthNumber - 1]
		else return monthsInPt[monthNumber - 1]
	}

	const handleCloseDetails = () => {
		setShowDetails(false)
	}

	const fetchData = useCallback(async () => {
		setLoading(true)
		const user = JSON.parse(localStorage.getItem('user'))
		const company = user.companyId
		const { year, status, month, country } = filters

		try {
			const [resPayslipList, respCountries] = await Promise.all([Payroll.getPayrollList(company, month, year, country, status), List.countries()])
			setPayslipList(resPayslipList)
			setCountries(respCountries.map(countryMapper.toDomain))
		} catch (error) {
			console.error('Error:', error)
		} finally {
			setLoading(false)
		}
	}, [filters])

	useEffect(() => {
		fetchData()
	}, [fetchData])

	return (
		<>
			<div className='tw-flex tw-justify-between tw-items-start tw-ml-16 2xl:tw-ml-10 22xl:tw-ml-0 tw-mr-6 2xl:tw-mr-16  tw-text-sm 2xl:tw-text-base'>
				<div className=''>
					<div className='tw-font-bold tw-text-2xl tw-mb-4'>Liquidaciones de Sueldo</div>
					<div className='tw-mb-5 tw-w-full '>{payslipTranslate.payslipDesc}</div>
				</div>
			</div>

			{loading ? (
				<Loading />
			) : (
				!showPaySlip && (
					<div className='tw-space-y-3 tw-text-sm 2xl:tw-text-base'>
						{payslipList && payslipList.length > 0 ? (
							payslipList.map(item => (
								<div className='border tw-p-4  tw-ml-16 2xl:tw-ml-10 22xl:tw-ml-0  tw-mr-6 2xl:tw-mr-16 tw-rounded-xl '>
									<div className='tw-flex tw-justify-between tw-items-center'>
										<div className='tw-flex tw-items-center tw-space-x-3'>
											<div className='tw-flex tw-items-center tw-space-x-3'>
												<div className='tw-font-bold'>{getMonthTranslate(item.month, language)}</div>
												<div className='tw-text-gray-500'>{item.year}</div>
												<div className='tw-text-gray-500'>{countries.find(c => c.id === item.countryId)?.value}</div>
											</div>
										</div>

										<div className='tw-flex tw-items-center tw-space-x-9'>
											{item.status === false && (
												<div className='tw-flex tw-items-center'>
													<div className='tw-text-gray-500'>Status</div>
													<div className='tw-font-black tw-flex tw-items-center'>
														<FaClock size={14} className='tw-mr-1 tw-ml-2' />
														{payslipTranslate.payslipRevision}
													</div>
												</div>
											)}
											<button
												className='tw-text-white tw-w-8 tw-h-8 tw-rounded-full tw-bg-purple-500 tw-flex tw-items-center tw-justify-center border-0'
												onClick={() => [setShowDetails(true), setSelectedData({ id: item.id, validatedBy: 'view' })]}
											>
												<FaEye />
											</button>
										</div>
									</div>
								</div>
							))
						) : (
							<div className='tw-text-center tw-text-base tw-text-gray-400 tw-py-12'>{payslipTranslate.payslipNoData}</div>
						)}
						{showDetails && <DetailsPayslip onCloseDetails={handleCloseDetails} employeeData={selectedData} />}
					</div>
				)
			)}
		</>
	)
}

export default EmployeePayslip
